import React, { useCallback, useEffect, useState } from 'react';
import BASE_URL from '../config';

const authHeaders = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('jwt_token')}` });
const btn = { background: '#2a3342', color: '#fff', border: '1px solid #3b4658', borderRadius: 6, padding: '7px 14px', cursor: 'pointer', fontSize: 14 };
const th = { textAlign: 'left', padding: '6px 10px', borderBottom: '1px solid #3b4658', color: '#9ca3af', fontSize: 12 };
const td = { padding: '6px 10px', borderBottom: '1px solid #232c3a', fontSize: 13 };
const fmt = (s) => (s ? new Date(s).toLocaleString('en-GB') : null);

/** Which devices this user has had, plus a lookup of any glasses/case serial's owner history. */
const DeviceHistoryPanel = ({ userId }) => {
  const [rows, setRows] = useState(null);
  const [serial, setSerial] = useState('');
  const [lookup, setLookup] = useState(null);
  const [err, setErr] = useState('');

  const load = useCallback(async () => {
    try {
      const r = await fetch(`${BASE_URL}/api/admin/users/${userId}/device-history/`, { headers: authHeaders() });
      setRows(r.ok ? await r.json() : []);
    } catch (e) { setRows([]); }
  }, [userId]);
  useEffect(() => { load(); }, [load]);

  const search = async (e) => {
    e.preventDefault();
    const s = serial.trim();
    if (!s) return;
    setErr('');
    try {
      const r = await fetch(`${BASE_URL}/api/admin/devices/${encodeURIComponent(s)}/history/`, { headers: authHeaders() });
      if (!r.ok) throw new Error('Lookup failed.');
      setLookup(await r.json());
    } catch (x) { setErr(x.message); setLookup(null); }
  };

  const ownerRows = (list) => (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead><tr><th style={th}>Glasses</th><th style={th}>Case</th><th style={th}>User</th><th style={th}>Linked</th><th style={th}>Unlinked</th></tr></thead>
      <tbody>
        {list.map((o, i) => (
          <tr key={i}>
            <td style={td}>{o.glasses_serial}</td>
            <td style={td}>{(o.cases || []).join(', ') || '—'}</td>
            <td style={td}>
              <a href={`/customer/${o.user_id}`} style={{ color: '#60a5fa' }}>{o.username || `user ${o.user_id}`}</a>
            </td>
            <td style={td}>{fmt(o.linked_at) || 'before tracking started'}</td>
            <td style={td}>{o.current ? <strong>current</strong> : fmt(o.unlinked_at)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div style={{ color: '#e5e7eb' }}>
      <h3 style={{ marginTop: 0 }}>Devices linked to this user</h3>
      {rows === null ? 'Loading…' : rows.length === 0 ? <p>No devices have been linked to this user since tracking started.</p> : ownerRows(rows)}

      <h3 style={{ marginTop: 24 }}>Look up a device</h3>
      <form onSubmit={search} style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input value={serial} onChange={(e) => setSerial(e.target.value)} placeholder="Glasses or case serial, e.g. SG304 or CA058"
          aria-label="Glasses or case serial"
          style={{ flex: '1 1 260px', maxWidth: 360, padding: 8, borderRadius: 6, border: '1px solid #3b4658', background: '#111827', color: '#e5e7eb' }} />
        <button type="submit" style={btn}>Show history</button>
      </form>
      {err && <div role="alert" style={{ color: '#f87171' }}>{err}</div>}
      {lookup && (
        <div>
          <h4 style={{ margin: '8px 0' }}>{lookup.serial}: owners over time</h4>
          {lookup.owners.length === 0 ? <p>No owner history recorded.</p> : ownerRows(lookup.owners)}
          <h4 style={{ margin: '14px 0 8px' }}>Glasses and case pairings</h4>
          {lookup.pairings.length === 0 ? <p>No pairing history recorded.</p> : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead><tr><th style={th}>Glasses</th><th style={th}>Case</th><th style={th}>Paired</th><th style={th}>Unpaired</th></tr></thead>
              <tbody>
                {lookup.pairings.map((p, i) => (
                  <tr key={i}>
                    <td style={td}>{p.glasses_serial}</td><td style={td}>{p.case_serial}</td>
                    <td style={td}>{fmt(p.paired_at) || '—'}</td><td style={td}>{p.unpaired_at ? fmt(p.unpaired_at) : <strong>current</strong>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default DeviceHistoryPanel;
